<template>

    <div id="container" class="mt-2">

        <!-- PROFILE BUTTON -->

        <!-- EDIT MODE -->
        <text-editor v-if="editMode && profileButtonVisible"
                     v-model="profileButtonTextModel"
                     hint="Improve profile button text">
            <v-badge
                v-if="editMode && profileButtonVisible"
                color="red"
                overlap
                :content="questionsAvailable"
            >
                <ninja-button
                    @click="profileButtonClicked"
                    :settings="settings"
                    :background="settings.profileButtonColor"
                >
                    {{ data.profile_button_text }}
                </ninja-button>
            </v-badge>

        </text-editor>

        <!-- NON EDIT MODE -->
        <div v-if="!editMode && profileButtonVisible" id="button">
            <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
                <template v-slot:activator="{ on }">

                    <div v-on="on">
                        <v-badge
                            color="red"
                            overlap
                            :content="questionsAvailable"
                        >
                            <ninja-button
                                @click="profileButtonClicked"
                                :settings="settings"
                                :background="settings.profileButtonColor"
                            >
                                {{ profileButtonText }}
                            </ninja-button>

                        </v-badge>
                    </div>
                </template>
                Button text can be edited in Sub Panel Landing Page Templates
            </v-tooltip>
        </div>

        <!-- COMMUNITY BUTTON -->

        <!-- EDIT MODE -->
        <text-editor v-if="editMode && communityButtonVisible"
                     v-model="communityButtonTextModel"
                     hint="Community button text">

            <ninja-button
                :settings="settings"
                :background="settings.communityButtonColor"
            >
                {{ data.community_button_text }}
            </ninja-button>

        </text-editor>

        <!-- NON EDIT MODE -->
        <div v-if="!editMode && communityButtonVisible" id="button">
            <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
                <template v-slot:activator="{ on }">

                    <div v-on="on">
                        <ninja-button
                            @click="communityButtonClicked"
                            :settings="settings"
                            :background="settings.communityButtonColor"
                        >
                            {{ data.community_button_text }}
                        </ninja-button>
                    </div>
                </template>
                Button text can be edited in Sub Panel Landing Page Templates
            </v-tooltip>
        </div>

        <!-- SUPPORT BUTTON -->

        <!-- EDIT MODE -->
        <text-editor v-if="editMode && supportButtonVisible"
                     v-model="supportButtonTextModel"
                     hint="Support button text">

            <ninja-button
                :settings="settings"
                text
            >
                {{ data.support_button_text }}
            </ninja-button>

        </text-editor>

        <!-- NON EDIT MODE -->
        <div v-if="!editMode && supportButtonVisible" id="button">
            <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="500">
                <template v-slot:activator="{ on }">

                    <div v-on="on">
                        <ninja-button
                            @click="supportButtonClicked"
                            :settings="settings"
                            text
                        >
                            {{ supportButtonText }}
                        </ninja-button>
                    </div>
                </template>
                Button text can be edited in Sub Panel Landing Page Templates
            </v-tooltip>
        </div>

    </div>
</template>

<script>

import TextEditor from "@/components/UI/TextEditor.vue";
import dynamicProfilingSettingsMixin from "@/components/mixins/dynamicProfilingSettingsMixin.js";
import NinjaButton from "@/components/UI/NinjaButton.vue";

export default {

    mixins: [
        dynamicProfilingSettingsMixin,
    ],

    components: {
        NinjaButton,
        TextEditor
    },

    props: {
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        settings: {
            type: Object,
            required: true
        },
        pageType: {
            type: String,
            required: true,
        },
        supportButtonText: {
            type: String,
            required: true,
        },
        profileButtonText: {
            type: String,
            required: true,
        },
        communityButtonText: {
            type: String,
            required: true,
        },
        questionsAvailable: {
            type: Number,
            required: false,
            default: 0
        },
        showProfileButton: {
            type: Boolean,
            required: true,
        },
        communityUrl: {
            type: String | null,
            required: true,
        },
        supportEmail: {
            type: String,
            required: true,
        },
        displayEditInfo: {
            type: Boolean,
            required: false,
            default: false,
        },
        mobileAppDownload: {
            type: String | null,
            required: false,
            default: null
        },
        componentData: {
            type: Object | null,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            data: {
                profile_button_text: null,
                community_button_text: null,
                support_button_text: null,
            },

            profileButtonEditorModel: false,
            communityButtonEditorModel: false,
            supportButtonEditorModel: false,

            memberAppHiddenPages: [
                'proxy-detected',
                'out-of-country',
                'security',
                'privacy',
                'terms',
                'cookies',
                'unsubscribe',
                'unsubscribe-confirmed',
                'registration',
                'registration-complete',
                'registration-disqualified',
                'hosted-detected'
            ],

            supportButtonHiddenPages: [
                'privacy',
                'terms',
                'cookies'
            ]
        }
    },

    mounted() {
        this.data.profile_button_text = this.profileButtonText;
        this.data.community_button_text = this.communityButtonText;
        this.data.support_button_text = this.supportButtonText;
    },

    watch: {
        profileButtonText(value) {
            this.data.profile_button_text = value;
        },

        communityButtonText(value) {
            this.data.community_button_text = value;
        },

        supportButtonText(value) {
            this.data.support_button_text = value;
        }
    },

    computed: {

        profileButtonTextModel: {
            get() {
                return this.profileButtonText;
            },
            set(value) {
                this.data.profile_button_text = value;
                this.emitObject();
            }
        },

        communityButtonTextModel: {
            get() {
                return this.communityButtonText;
            },
            set(value) {
                this.data.community_button_text = value;
                this.emitObject();
            }
        },

        supportButtonTextModel: {
            get() {
                return this.supportButtonText;
            },
            set(value) {
                this.data.support_button_text = value;
                this.emitObject();
            }
        },

        communityButtonVisible() {
            if (!this.communityUrl) return false;
            if (this.memberAppHiddenPages.includes(this.pageType)) return false;
            return this.settings.showCommunityButton;
        },

        supportButtonVisible() {
            if (this.supportButtonHiddenPages.includes(this.pageType)) return false;
            return this.settings.showSupportButton && this.supportButtonText;
        },

        profileButtonVisible() {
            if (!this.showProfileButton) return false;
            return this.profilingEnabledPages.includes(this.pageType);
        },
    },

    methods: {

        supportButtonClicked() {

            if (this.editMode) {
                this.supportButtonEditorModel = true;
                return;
            }

            this.sendToUrl('mailto: ' + this.supportEmail, true);

        },

        communityButtonClicked() {

            if (this.editMode) {
                this.communityButtonEditorModel = true;
                return;
            }

            let url = this.communityUrl;

            if (this.componentData && this.componentData.email) {

                url += '?email=' + encodeURIComponent(this.componentData.email);

            } else {

                url = this.appendEmailFromTheCurrentUrl(url);
            }

            this.sendToUrl(url);
        },

        appendEmailFromTheCurrentUrl(url) {

            let searchParams = new URLSearchParams(window.location.search);

            let email = searchParams.get('email');

            if (email) {
                url += '?email=' + encodeURIComponent(email);
            }

            return url;
        },

        profileButtonClicked() {
            if (this.editMode) {
                this.profileButtonEditorModel = true;
            } else {
                this.$emit('profile');
            }
        },

        emitObject() {
            this.$emit('change:subPanelTranslations', this.data);
        }
    }
}
</script>

<style scoped>

#container {
    width: 100%;
    padding-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

#button {
    padding-top: 5px;
    display: table;
}

@media only screen and (max-width: 767px) {
    #container {
        width: 100%;
        padding-top: 10px;
    }
}

@media only screen and (max-width: 767px) {
    #button {
        display: block;
        text-align: center;
        float: none;
        width: 100%;
    }
}
</style>
